export default __webpack_public_path__ + "static/helles_badge_EN-a8b901c39cf598a8a087ad870e2cdb6c.svg";